const fleetSizeList: string[] = ['1-50', '51-500', '501-1000', '1000+'];

export default fleetSizeList;
